import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/img/heart.svg'
import _imports_1 from '@/img/bag_of_cash.svg'
import _imports_2 from '@/img/tree.svg'
import _imports_3 from '@/img/leaf.svg'


const _hoisted_1 = { class: "box maxw-400 mx-auto" }
const _hoisted_2 = { class: "boxTitle d-flex justify-content-between" }
const _hoisted_3 = { class: "text-center" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"text-green my-3\"><img src=\"" + _imports_0 + "\"> + <img src=\"" + _imports_1 + "\"> + <img src=\"" + _imports_2 + "\"> + <img src=\"" + _imports_3 + "\"></div>", 1)
const _hoisted_5 = { class: "mt-1 px-2" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "mt-2" }, null, -1)
const _hoisted_7 = { class: "px-4 mt-4" }
const _hoisted_8 = { class: "d-flex justify-content-between mt-4" }
const _hoisted_9 = { class: "roundedBox w-100" }
const _hoisted_10 = { class: "text-orange" }
const _hoisted_11 = { class: "fw-light" }
const _hoisted_12 = { class: "big" }
const _hoisted_13 = { class: "roundedBox w-100" }
const _hoisted_14 = { class: "text-orange" }
const _hoisted_15 = { class: "fw-light" }
const _hoisted_16 = { class: "big" }
const _hoisted_17 = { class: "d-flex justify-content-between mt-4" }
const _hoisted_18 = { class: "roundedBox w-100 alberiSalvati" }
const _hoisted_19 = { class: "text-orange" }
const _hoisted_20 = { class: "fw-light" }
const _hoisted_21 = { class: "big" }
const _hoisted_22 = { class: "roundedBox w-100 alberiSalvati" }
const _hoisted_23 = { class: "text-orange" }
const _hoisted_24 = { class: "fw-light" }
const _hoisted_25 = { class: "big" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_localized_text, {
        localizedKey: "I danni del fumo",
        text: "I danni del fumo"
      }),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-secondary",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openCalcoloModal && _ctx.openCalcoloModal(...args)))
      }, [
        _createVNode(_component_localized_text, {
          localizedKey: "Inserisci i dati per il calcolo",
          text: "Inserisci i dati per il calcolo"
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_localized_text, {
          class: "fs-14",
          localizedKey: "Calcola l'impatto del fumo sulla vita di una persona",
          text: "Calcola l'impatto del fumo sulla vita di una persona"
        })
      ]),
      _hoisted_6
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_localized_text, {
              localizedKey: "Totale speso",
              text: "Totale speso"
            })
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_localized_text, {
              localizedKey: "Un pacchetto costa in media 5.30 €",
              text: "Un pacchetto costa in media 5.30 €"
            })
          ]),
          _createElementVNode("div", _hoisted_12, [
            (_ctx.risparmiato != '-')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(_ctx.$filters.currency(_ctx.risparmiato, 0)) + " €", 1)
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(_toDisplayString(_ctx.risparmiato), 1)
                ], 64))
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_localized_text, {
              localizedKey: "Speranza di vita persa",
              text: "Speranza di vita persa"
            })
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_localized_text, {
              localizedKey: "Ogni sigaretta toglie 11 minuti",
              text: "Ogni sigaretta toglie 11 minuti"
            })
          ]),
          _createElementVNode("div", _hoisted_16, [
            (_ctx.speranzaVita != '-')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(_ctx.$filters.tempofromminuti(_ctx.speranzaVita)), 1)
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(_toDisplayString(_ctx.speranzaVita), 1)
                ], 64))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createVNode(_component_localized_text, {
              localizedKey: "Alberi abbattuti",
              text: "Alberi abbattuti"
            })
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createVNode(_component_localized_text, {
              localizedKey: "300 sigarette = 1 albero",
              text: "300 sigarette = 1 albero"
            })
          ]),
          _createElementVNode("div", _hoisted_21, [
            (_ctx.alberi != '-')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(_ctx.$filters.currency(_ctx.alberi)), 1)
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(_toDisplayString(_ctx.alberi), 1)
                ], 64))
          ])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _createVNode(_component_localized_text, {
              localizedKey: "CO2 Emessa",
              text: "CO2 Emessa"
            })
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createVNode(_component_localized_text, {
              localizedKey: "1 sigaretta = 14g CO2",
              text: "1 sigaretta = 14g CO2"
            })
          ]),
          _createElementVNode("div", _hoisted_25, [
            (_ctx.co2Risparmiata != '-')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(_ctx.$filters.currency(_ctx.co2Risparmiata, 0)) + " kg", 1)
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(_toDisplayString(_ctx.co2Risparmiata), 1)
                ], 64))
          ])
        ])
      ])
    ])
  ]))
}